import type { ChatPoll } from './chatHttp.service'

/** Recompute author/voter visibility from shared poll payload (REST or socket). */
export function withPollViewerState(poll: ChatPoll | null | undefined, resourceId: string): ChatPoll | null {
  if (!poll) return null
  const myId = String(resourceId || '')
  const votes = poll.votes || []
  const myVote = votes.find(vote => String(vote.resourceId) === myId)
  const isAuthor = String(poll.createdBy) === myId
  const hasVoted = !!myVote
  const showResults = isAuthor || hasVoted
  const totalVotes = votes.length || poll.totalVotes || 0

  const options = (poll.options || []).map((option) => {
    const voteCount = votes.length
      ? votes.filter(vote => String(vote.optionId) === String(option._id)).length
      : option.voteCount
    return {
      ...option,
      voteCount,
      percentage: totalVotes ? Math.round((voteCount / totalVotes) * 100) : 0,
    }
  })

  return {
    ...poll,
    options,
    totalVotes,
    isAuthor,
    hasVoted,
    myOptionId: myVote ? myVote.optionId : null,
    showResults,
  }
}
